import Service from '../service';

export default class ApplicationService extends Service {
  baseApi = '/user/application-wagon';

  async changeStatus(formData) {
    const url = `${this.baseApi}/status`;
    return await this.postFormData(url, formData);
  }

  async updateGy12(body) {
    const url = `${this.baseApi}/gy12`;
    return await this.putResource(url, body);
  }

  async getStatusHistory(query) {
    const url = `${this.baseApi}/status`;
    return await this.getResource(url, query);
  }

  async getApplications(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async getConsolidationFiles(query = { type: 0 }) {
    const url = `${this.baseApi}/consolidate`;
    return await this.getResource(url, query);
  }

  async filter(query, field) {
    const url = `${this.baseApi}/filter/${field}`;
    return await this.getResource(url, query);
  }

  async getAgreedApplications(query) {
    const url = `${this.baseApi}/agreed`;
    return await this.getResource(url, query);
  }

  async postApplication(formData) {
    const url = `${this.baseApi}`;
    return await this.postFormData(url, formData);
  }

  async exportApplications(body) {
    const url = `${this.baseApi}/export`;
    return await this.postResource(url, body);
  }

  async importApplications(formData) {
    const url = `${this.baseApi}/import`;
    return await this.postFormData(url, formData);
  }
}
